import { render } from "./KanbanHeader.vue?vue&type=template&id=ad8890ea&scoped=true"
import script from "./KanbanHeader.vue?vue&type=script&lang=js"
export * from "./KanbanHeader.vue?vue&type=script&lang=js"

import "./KanbanHeader.vue?vue&type=style&index=0&id=ad8890ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad8890ea"]])

export default __exports__